var map = {
	"./de.json": 487,
	"./en.json": 488,
	"./es.json": 489,
	"./fr.json": 490,
	"./id.json": 491,
	"./it.json": 492,
	"./ja.json": 493,
	"./ko.json": 494,
	"./pt.json": 495,
	"./ru.json": 496,
	"./th.json": 497,
	"./tr.json": 498,
	"./tw.json": 499,
	"./vi.json": 500,
	"./zh.json": 501
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 486;